import React from "react";
import Spinner from "./Spinner";

export default function FullPageLoader() {
	return (
		<div className="fixed inset-0 bg-white flex flex-col items-center justify-center z-50">
			<div className="flex flex-col items-center space-y-6">
				<img src="/logo.png" alt="logo" className="h-16 w-auto" />
				<Spinner />
			</div>
		</div>
	);
}
